import { CartPreviewStyled, CartPreviewTextStyled, CartPreviewTotalPriceStyled } from './CartPreview.style';
import { LoyaltyClubEarned } from 'components/Blocks/LoyaltyClubEarned/LoyaltyClubEarned';
import { DiscountPreview } from 'components/Pages/Cart/DiscountPreview/DiscountPreview';
import { useCurrentCart } from 'connectors/cart/Cart';
import { isB2bDomain } from 'helpers/isDomainLocale';
import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import { getSellingPriceByDomain } from 'hooks/formatting/useFormatPrice';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useDomainConfig } from 'hooks/useDomainConfig';

const CartPreview: FC = () => {
    const testIdentifier = 'pages-cart-cartpreview';

    const domainConfig = useDomainConfig();
    const t = useTypedTranslationFunction();
    const { formatPriceNumber: formatPrice } = useFormatPrice();
    const { cart, isCartEmpty } = useCurrentCart();

    if (cart === null || isCartEmpty === true) {
        return null;
    }

    return (
        <>
            <DiscountPreview />
            <CartPreviewStyled data-testid={testIdentifier}>
                <CartPreviewTextStyled>
                    {isB2bDomain(domainConfig) ? t('Total price excl. VAT') : t('Total price incl. VAT')}
                </CartPreviewTextStyled>
                <CartPreviewTotalPriceStyled data-testid={testIdentifier + '-total'}>
                    {formatPrice(
                        getSellingPriceByDomain(cart.totalItemsPrice, domainConfig) - (cart.loyaltyClubDiscount ?? 0),
                    )}
                </CartPreviewTotalPriceStyled>
            </CartPreviewStyled>
            <LoyaltyClubEarned pointsWithPrice={cart.loyaltyClubPointsObtained} isSimplified={false} />
        </>
    );
};

export default CartPreview;
